import { render, staticRenderFns } from "./PolicyStatementsEditor.vue?vue&type=template&id=983f20f0&scoped=true&"
import script from "./PolicyStatementsEditor.vue?vue&type=script&lang=js&"
export * from "./PolicyStatementsEditor.vue?vue&type=script&lang=js&"
import style0 from "./PolicyStatementsEditor.vue?vue&type=style&index=0&id=983f20f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983f20f0",
  null
  
)

export default component.exports